import React from 'react'

import dynamic from 'next/dynamic'

import { Button } from 'components/v2/Button'
import { Row } from 'components/v2/Grid'
import { Text } from 'components/v2/Text'

const LazyImage = dynamic(() => import('components/shared/LazyImage'), {
	ssr: false
})

const WhyDoTherapy = ({ handleModal }) => (
	<section id='why-do-therapy'>
		<Row className='min-w-full flex-wrap py-16'>
			<Row className='mx-auto max-w-[1200px] flex-wrap px-3'>
				<div className='flex w-full min-w-0 flex-col px-2 md:flex-[0_0_50%]'>
					<Row className='mb-6 sm:mb-0'>
						<LazyImage
							src='/static/images/home-whydotherapy.png'
							alt='Porque fazer tereapia'
						/>
					</Row>
				</div>
				<div className='flex w-full min-w-0 flex-col px-2 md:flex-[0_0_50%]'>
					<Row className='min-w-full flex-wrap justify-between'>
						<Text
							as='h2'
							variant='regular'
							className='mb-3 text-2xl font-semibold text-gray-800 md:text-3xl'
						>
							Saúde mental é inegociável!
						</Text>
						<Text
							variant='regular'
							className='mb-4 font-bold leading-6 text-gray-800'
						>
							O Brasil lidera rankings globais de ansiedade e está entre os
							países com mais casos de depressão diagnosticados. Ignorar esse
							cenário tem custo humano, social e econômico.
						</Text>
						<Text
							variant='regular'
							className='mb-6 font-bold leading-6 text-gray-800'
						>
							A Vittude existe para mudar essa lógica e construir um futuro mais
							saudável, com cuidado contínuo e decisões baseadas em evidência.
							Essa transformação é coletiva.
						</Text>
						<Row className='min-w-full flex-wrap'>
							<Button
								variant='primary-outlined'
								className='h-11 text-sm font-semibold'
								onClick={handleModal}
							>
								Começar agora
							</Button>
						</Row>
					</Row>
				</div>
			</Row>
		</Row>
	</section>
)

export default WhyDoTherapy
